module.exports = __webpack_public_path__ + "static/media/lp-2.b56bc15d.png";